<template>
  <div class="scmd_layout-box" >
    <!-- 按钮 -->
    <!-- <Button v-if = '(conf.componentType == "0"&&conf.componentCode == "addBtn"&&!isSlide)' @click = '_handleClick' >新增</Button>
    <Button v-if = '(conf.componentType == "0"&&conf.componentCode == "deleBtn"&&!isSlide)' @click = '_handleClick' >删除</Button>
    <Button v-if = '(conf.componentType == "0"&&conf.componentCode == "updateBtn"&&!isSlide)' @click = '_handleClick' >编辑</Button>
    <Button v-if = '(conf.componentType == "0"&&conf.componentCode == "queryBtn"&&!isSlide)' @click = '_handleClick' >查询</Button>
    <Button v-if = '(conf.componentType == "0"&&conf.componentCode == "diyBtn"&&!isSlide)' @click = '_handleClick' >{{conf.Parameter.componentName}}</Button>
    <DropdownItem v-if = '(conf.componentType == "0"&&conf.componentCode == "addBtn"&&isSlide)' ><div @click = '_handleClick'>新增</div></DropdownItem>
    <DropdownItem v-if = '(conf.componentType == "0"&&conf.componentCode == "deleBtn"&&isSlide)' ><div @click = '_handleClick'>删除</div></DropdownItem>
    <DropdownItem v-if = '(conf.componentType == "0"&&conf.componentCode == "updateBtn"&&isSlide)' ><div @click = '_handleClick'>编辑</div></DropdownItem>
    <DropdownItem v-if = '(conf.componentType == "0"&&conf.componentCode == "queryBtn"&&isSlide)' ><div @click = '_handleClick'>查询</div></DropdownItem>
    <DropdownItem v-if = '(conf.componentType == "0"&&conf.componentCode == "diyBtn"&&isSlide)' ><div @click = '_handleClick'>{{conf.Parameter.componentName}}</div></DropdownItem> -->
    <Button v-if = '(conf.componentType == "0"&&!isSlide)' @click = '_handleClick' >{{conf.componentName}}</Button>
    <DropdownItem v-if = '(conf.componentType == "0"&&isSlide)' ><div @click = '_handleClick'>{{conf.componentName}}</div></DropdownItem>
    <!-- 字段 -->
    <dl v-if = '(conf.componentType == "3")&&conf.fieldsType!="groupTitle"&&conf.fieldType != "1"' class = 'header-field-item clear-fix'>
        <dt :title = 'conf.componentName' class = 'field-dt'>
            {{(this.tit || conf.componentName)}}
        </dt>
        <dd>
            <span v-if = 'conf.fieldType != "16"&&conf.fieldType == "8"||conf.componentCode == "task_phone"||conf.componentCode == "cust_phone"' :title = "fieldVal | filterSens">{{fieldVal | filterSens}}</span>
            <span v-if = 'conf.fieldType != "16"&&conf.fieldType != "15"&&conf.fieldType != "8"&&conf.componentCode != "task_phone"&&conf.componentCode != "cust_phone"' :title = "fieldVal">{{fieldVal}}</span>
            <CFileField v-if = 'conf.fieldType == "16"' :ids = "fieldVal" :itemValue = "conf" />
            <CImgPreview v-if = 'item' :key = 'index' v-for = '(item,index) in imgFields' style = 'width:45px;height:45px;margin-right:5px;' :src = '`${envConst["API_BASE_URL"]}/file/filemanage/downloadFileByIdAndName/${item}?renameFileName=${new Date().getTime()}-${index+1}`' />          
        </dd>
    </dl>
    <!-- 多行文本字段 -->
    <dl v-if = 'conf.fieldType == "1"' class = 'header-field-item clear-fix'>
        <dt class = 'field-dt'>
            {{(this.tit || conf.componentName)}}
        </dt>
        <!-- 单独处理顶部多行文本字段，不换行 -->
        <dd v-if = "isTopField">
          {{fieldVal}}
        </dd>
        <dd v-else style = 'white-space:inherit;'>
          {{fieldVal}}
        </dd>
    </dl>
    <!-- 栅格 -->
    <MyGrid :grid-conf = 'conf' v-if = '(conf.componentType == "boxComponent"&&conf.componentCode == "Grid")' />
    <!-- 分组栏 -->
    <Divider orientation="left"  v-if='conf.componentType == "3"&&conf.fieldsType==="groupTitle"'>
      <span >{{conf.fieldsTitle}}</span>
    </Divider>
    <!-- 栅格 -->
    <Myiframe :conf = 'conf' v-if = '(conf.componentType == "boxComponent"&&conf.componentCode == "otherPage")' />
  </div>
</template>

<script>
import MyGrid from './showGrid.vue';
import Myiframe from './myiframe.vue';
import envConst from '@/env-const.js';
function getIndex(str,strpram,index){
  var strValue=str;
  var strValue1="";
  var value=0;
  for(var i =0;i < index;i++){
  strValue1 = strValue.substring(0,strValue.indexOf(strpram));
  strValue = strValue.substring(strValue1.length+1);
  value += (strValue1.length+1);
  }
  return value;
}
export default {
  data(){
    return {
      data:'',
      envConst
    }
  },
  created(){
  },
  computed:{
    imgFields(){
      let imgFieldsList = [];
      try{
        if(this.conf.fieldType == "15"){
          imgFieldsList = this.fieldVal.split(',');
        }
      }catch(e){

      }
      return imgFieldsList;
    },
    fieldVal(){
      console.log(this.conf)
      if(this.conf.fieldType=='14'){
        let value = this.$store.state.main.layoutStore.fieldParams[this.conf.componentCode] || ""
        if(value){
            let _i = getIndex(value,"/",3)
            let _val141 = value
            _val141 = _val141.substring(0,_i-1).split("/")
            let _val142 = value.substring(_i,value.length)
            return _val141.join("")+_val142
        }else{
          return value
        }
      }else{
        return this.$store.state.main.layoutStore.fieldParams[this.conf.componentCode] || ""
      }
    }
  },
  mounted(){
    if(this.isSlide){
      this._css('display','block');
    }
    if(this.conf.componentType == 'boxComponent'||this.conf.fieldsType==="groupTitle"){
      this._css('display','block');
      if(this.conf.fieldsType==="groupTitle"){
        this._css('padding','10px 0');
        this._css('clear','both');
      } 
    } 
    if(this.conf.componentType == '3'&&this.conf.fieldsType!="groupTitle"){
      this._css('display','block');
      this._css('width',`${(1/this.$store.state.main.layoutStore.columnNum)*100}%`);
      this._css('float','left');
      this.$el.className = this.$el.className+ ' in-fields';
      if(this.conf.fieldType == "15"||this.conf.fieldType == "16"||(this.conf.fieldType == "1"&&!this.isTopField)){//图片和附件、多行文本类型单独一行
        this._css('display','block');
        this._css('float','none');
        this._css('min-height','50px');
        this._css('width','100%');
        this._css('clear','both');
        this.$el.className = this.$el.className+ ' in-img-fields';
      }
    }
  },
  methods: {
    _handleClick(){
      this.$emit('_submitBtnEvent',{
        ...this.conf
      })
    },
    _css(attr,val){
      this.$el.style[attr] = val;
    }
  },
  components: {
    MyGrid,
    Myiframe,
  },
  props: {
    conf: Object,
    isSlide: Boolean,
    index: Number,
    tit: String,
    isTopField: Boolean
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang = 'less'>
.scmd_layout-box{
  display:inline-block;
  dl{
      display: block;
      box-sizing: border-box;
      padding-right:20px;
      dt{
          color: #9999A4;
          font-size:14px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          height:30px;
          line-height:30px;
      }
      dd{  
          color:#5E5F77;
          font-size:16px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          min-height:30px;
          line-height:30px;
      }
  }
}
.header-top-left{
    .field-dt{
      display:none;
    }
    .scmd_layout-box{
      width: auto!important;
    }
    dd{
      color:#515a6e!important;
      font-size:20px!important;
      font-weight:600;
    }
  }
.drag-layout-tabs-content1{
  .in-img-fields{
    dd{
      overflow: visible!important;
    }
  }
  .in-fields{
    /* width:33%!important; */
    min-height:40px;
    dl{
      display:flex;
    }
    dt{
      /* width:40%; */
      /* float:left; */
      width: 150px;
    }
    dd{
      /* width:60%; */
      /* float:left; */
      flex: 1;
      /* text-indent: 10px; */
      padding-left:10px;
      font-size:14px;
    }
  }
}
.clear-fix:after{
  content:'';
  height:0;
  display:block;
  clear:both;
  overflow:hidden;
  visibility:hidden;
}
</style>
